import {IDeviceMinAvg} from '../../../dashboard/shared';
import * as airData from '../actions/air-data.action';

export interface State {
  entities: { [deviceUuid: string]: IDeviceMinAvg[] };
  selectedDeviceUuidList: string[]; // device_uuid: {deviceType}_{deviceId}
  fromDate: Date;
  toDate: Date;
  interval: number;
  isLoading: boolean;
}

export const initialState: State = {
  entities: {},
  selectedDeviceUuidList: [],
  fromDate: ((d: Date) => new Date(d.setHours(0, 0, 0, 0)))(new Date),  // Default to yesterday
  toDate: ((d: Date) => new Date(d.setHours(23, 59, 59, 59)))(new Date),
  interval: 15,
  isLoading: false
};

/**
 * Because our object state tree is read-only, our response for every action
 * must return a new state object without mutating the previous state object.
 */

export function reducer(state = initialState, action: airData.Actions): State {
  switch (action.type) {
    case airData.REQUEST_SUCCESS: {
      const payload = <{
        entities: { [deviceUuid: string]: IDeviceMinAvg[] },
        timeRange: { fromDate: Date, toDate: Date }
      }>action.payload;

      const newUuidList = Object.keys(payload.entities).map((deviceUuid: string) => deviceUuid);

      // Entities have dependency on both selectedDeviceUuidList & timeRange
      // Therefore, initiate state with all those values together
      return {
        ...state,
        selectedDeviceUuidList: newUuidList,
        entities: {...payload.entities},
        fromDate: payload.timeRange.fromDate,
        toDate: payload.timeRange.toDate,
        isLoading: false
      }
    }

    case airData.START_LOADING: {
      return {...state, isLoading: true};
    }

    case airData.CLEAR_AIR_DATA: {
      return {
        ...state,
        selectedDeviceUuidList: [],
        entities: {},
        isLoading: false
      };
    }

    case airData.UPDATE_DEVICE_LIST_FAIL: {
      console.warn('AIR_DATA: Update Device List Fail');
      return {...state, isLoading: false};
    }
    case airData.UPDATE_TIME_RANGE_FAIL: {
      console.warn('AIR_DATA: Update Time Range Fail');
      return {...state, isLoading: false};
    }
    case airData.REQUEST_FAIL: {
      console.warn('AIR_DATA: Request Fail');
      return {...state, isLoading: false};
    }

    default:
      return state;
  }
};

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getEntities = (state: State) => state.entities;
export const getSelectedDeviceUuidList = (state: State) => state.selectedDeviceUuidList;
export const getTimeRange = (state: State) => {
  return {
    'fromDate': state.fromDate,
    'toDate': state.toDate
  };
};
export const getLoadingStatus = (state: State) => state.isLoading;
